const { mediums } = require("./enums");

export default function getAspectRatio(medium) {
  return hasTallPoster(medium) ? 2 / 3 : 1;
}

export function hasTallPoster(medium) {
  switch (medium) {
    case mediums.FILM:
    case mediums.TV_SHOW:
    case mediums.BOOK:
      return true;
    case mediums.ALBUM:
    case mediums.PODCAST:
      return false;
    default:
      throw new Error("Invalid medium");
  }
}
